export type ServiceCallDashboardTab = 'reminders' | 'faults';

export const SERVICE_CALL_DASHBOARD_TAB_PARAM = 'tab';

export const parseServiceCallDashboardTab = (
  value: string | null | undefined
): ServiceCallDashboardTab => (value === 'faults' ? 'faults' : 'reminders');

export const buildServiceCallDashboardHref = (
  dashboardPath: string,
  tab: ServiceCallDashboardTab
): string => (tab === 'faults' ? `${dashboardPath}?tab=faults` : dashboardPath);

export const formatServiceCallDashboardTabLabel = (label: string, count: number): string =>
  `${label} (${count})`;

export type ServiceCallDashboardFilterValues = {
  businessId: string;
  vehicleId: string;
  dateGte: string;
  dateLte: string;
  isRead: '' | 'true' | 'false';
};

export type ServiceCallDashboardWhereInput = {
  businessId?: string;
  vehicleId?: string;
  date?: {
    gte?: string;
    lte?: string;
  };
  isRead?: boolean;
};

export const defaultServiceCallDashboardFilter = (): ServiceCallDashboardFilterValues => ({
  businessId: '',
  vehicleId: '',
  dateGte: '',
  dateLte: '',
  isRead: 'false',
});

export const isServiceCallDashboardFilterActive = (
  values: ServiceCallDashboardFilterValues,
  tab: ServiceCallDashboardTab
): boolean => {
  if (values.businessId || values.vehicleId) {
    return true;
  }

  if (tab === 'reminders' && (values.dateGte || values.dateLte)) {
    return true;
  }

  const defaults = defaultServiceCallDashboardFilter();

  if (tab === 'faults' && values.isRead !== defaults.isRead) {
    return true;
  }

  return false;
};

const toStartOfDayIso = (value: string): string => {
  const date = new Date(`${value}T00:00:00`);
  return date.toISOString();
};

const toEndOfDayIso = (value: string): string => {
  const date = new Date(`${value}T23:59:59.999`);
  return date.toISOString();
};

export const buildServiceCallDashboardWhere = (
  values: ServiceCallDashboardFilterValues,
  tab: ServiceCallDashboardTab
): ServiceCallDashboardWhereInput => {
  const where: ServiceCallDashboardWhereInput = {};

  if (values.businessId) {
    where.businessId = values.businessId;
  }

  if (values.vehicleId) {
    where.vehicleId = values.vehicleId;
  }

  if (tab === 'reminders' && (values.dateGte || values.dateLte)) {
    where.date = {
      ...(values.dateGte ? { gte: toStartOfDayIso(values.dateGte) } : {}),
      ...(values.dateLte ? { lte: toEndOfDayIso(values.dateLte) } : {}),
    };
  }

  if (tab === 'faults' && values.isRead !== '') {
    where.isRead = values.isRead === 'true';
  }

  return where;
};

export const formatDashboardVehicleLabel = (vehicle: {
  name?: string | null;
  registerNumber?: string | null;
  VIN?: string | null;
  brand?: string | null;
  model?: string | null;
}): string => {
  let name: string;

  if (vehicle.brand && vehicle.model) {
    name = `${vehicle.brand} ${vehicle.model}`;
  } else if (vehicle.name) {
    name = vehicle.name;
  } else if (vehicle.registerNumber) {
    name = vehicle.registerNumber;
  } else if (vehicle.VIN) {
    name = vehicle.VIN;
  } else {
    name = 'Ajoneuvo';
  }

  if (vehicle.registerNumber && vehicle.registerNumber !== name) {
    return `${name} (${vehicle.registerNumber})`;
  }

  return name;
};
